export default __webpack_public_path__ + "static/media/Por-que-escolher-a-All-Just.e9a78f57.png";